// A cor do produto (cadastrada em Produtos > Cor) aparece no app como complemento
// da descrição. Estas funções concentram essa mesma regra no admin para que o
// nome da cor apareça igual em todas as listagens e buscas de produto.

// Aceita tanto o produto quanto o item do pedido ({ product: {...} }).
export function productColor(product) {
  if (!product) {
    return '';
  }

  const target = product.product || product;

  // Variação sem cor própria herda a cor do produto principal.
  const color = (target.color && target.color.name)
    ? target.color
    : (target.main_product && target.main_product.color);

  return (color && color.name) ? color.name : '';
}

// Descrição completa para rótulos de uma linha só (multiselect, resultado de busca).
export function productDescription(product) {
  if (!product) {
    return '';
  }

  // O backend já monta fullDescription com a variação; fora dele montamos aqui.
  let description = product.fullDescription || product.description || '';
  if (!product.fullDescription && product.variation_description) {
    description = `${description} - ${product.variation_description}`;
  }

  const color = productColor(product);
  if (color && !description.toLowerCase().includes(color.toLowerCase())) {
    description = `${description} - ${color}`;
  }

  return description;
}

export default { productColor, productDescription };
